export const SliderItems = [
  {
    id: "62d006c9c020372b553c8946",
    img: `https://firebasestorage.googleapis.com/v0/b/tortas-bffc7.appspot.com/o/asada-fries-removebg-min.png?alt=media&token=7f7ebdcf-a22a-4566-bf8c-d0519bcb9c80`,
    title: "Asada Fries",
    desc: "Try Our Delicious Asada Fries",
    bg: "f5fafd",
    alt: "Image of a yellow plate with Asada Fries for a photo slider.",
  },
  {
    id: "62d00602c020372b553c8944",
    img: `https://firebasestorage.googleapis.com/v0/b/tortas-bffc7.appspot.com/o/cubana-removebg-preview.png?alt=media&token=6aed1aae-a5a4-4893-90d6-54b83cf25927`,
    title: "Torta Cubana",
    desc: "Try Our Flavory Torta Cubana",
    bg: "fbf0f4",
    alt: "Image of a torta cubana with melthing cheese for two second image of the photo slider.",
  },
  {
    id: "62d00814c020372b553c894a",
    img: `https://firebasestorage.googleapis.com/v0/b/tortas-bffc7.appspot.com/o/mole-removebg-min.png?alt=media&token=fe32932d-58a6-43d7-b862-1af5a8a90475`,
    title: "Pollo Con Mole",
    desc: "Try Our Tasty Pollo Con Mole",
    bg: "fcf1ed",
    alt: "Image of a green plate with pollo con mole dish for the final image in the photo slider.",
  },
];

export const categories = [
  {
    id: 1,
    img: `https://firebasestorage.googleapis.com/v0/b/tortas-bffc7.appspot.com/o/cubana.jpg?alt=media&token=94876bed-3776-4093-9134-57f064c4ae7d`,
    title: "Tortas",
    cat: "tortas",
    alt: "Image of a torta cubana for the Tortas Category",
  },
  {
    id: 2,
    img: `https://firebasestorage.googleapis.com/v0/b/tortas-bffc7.appspot.com/o/burrito-wet.JPG?alt=media&token=8f2af152-f2f7-4a9c-be57-93db3f15fd6b`,
    title: "Burritos",
    cat: "burritos",
    alt: "Image of a wet burrito for the Burritos Category",
  },
  {
    id: 3,
    img: `https://firebasestorage.googleapis.com/v0/b/tortas-bffc7.appspot.com/o/tacos-buche.jpeg?alt=media&token=7ed5f819-0c85-45ba-b779-68dbaffffb27`,
    title: "Tacos",
    cat: "tacos",
    alt: "Image of a taco for the Tacos Category",
  },
];

// export const popularProducts = [
//   {
//     id: 1,
//     img: `${AsadaFries}`,
//   },
//   {
//     id: 2,
//     img: `${AsadaFries}`,
//   },
//   {
//     id: 3,
//     img: `${AsadaFries}`,
//   },
//   {
//     id: 4,
//     img: `${AsadaFries}`,
//   },
//   {
//     id: 5,
//     img: `${AsadaFries}`,
//   },
//   {
//     id: 6,
//     img: `${AsadaFries}`,
//   },
//   {
//     id: 7,
//     img: `${AsadaFries}`,
//   },
//   {
//     id: 8,
//     img: `${AsadaFries}`,
//   },
// ];

export const extrasInfo = [
  {
    id: 1,
    option: `Guacamole + $ 1.50`,
    price: 1.5,
  },
  {
    id: 2,
    option: `Cheese + $ 1.25`,
    price: 1.25,
  },
  {
    id: 3,
    option: `Cilantro + $ 1.00`,
    price: 1.0,
  },
  {
    id: 4,
    option: `Onions + $ 1.00`,
    price: 1.0,
  },
  {
    id: 5,
    option: `Pico De Gallo + $ 1.25`,
    price: 1.25,
  },
  {
    id: 6,
    option: `Sour Cream + $ 1.25`,
    price: 1.25,
  },
  {
    id: 7,
    option: `Meat + $ 1.99`,
    price: 1.99,
  },
  {
    id: 8,
    option: `Enchilada Sauce + $ 1.25`,
    price: 1.25,
  },
  {
    id: 9,
    option: `Lettuce + $ 0.00`,
    price: 0.0,
  },
];

export const menuCatArray1 = [
  {
    id: 1,
    option: `All`,
    value: "All",
  },
  {
    id: 2,
    option: `Popular`,
    value: `popular`,
  },
  {
    id: 3,
    option: `Tacos`,
    value: `tacos`,
  },
  {
    id: 4,
    option: `Tortas`,
    value: `tortas`,
  },
  {
    id: 5,
    option: `Burritos`,
    value: `burritos`,
  },
  {
    id: 6,
    option: `Beverages`,
    value: "beverages",
  },
  {
    id: 7,
    option: `Specialties`,
    value: "specialties",
  },
  {
    id: 8,
    option: `Combinations`,
    value: "combos",
  },
];

export const menuCatArray2 = [
  {
    id: 9,
    option: `Soups`,
    value: "soups",
  },
  {
    id: 10,
    option: `Breakfast`,
    value: `breakfast`,
  },
  {
    id: 11,
    option: `Shakes`,
    value: `shakes`,
  },
  {
    id: 12,
    option: `Burgers`,
    value: `hamburgers`,
  },
  {
    id: 13,
    option: `Appetizers`,
    value: `appetizers`,
  },
  {
    id: 14,
    option: `Ensaladas`,
    value: `salads`,
  },
  {
    id: 15,
    option: `Taquitos`,
    value: "taquitos",
  },
];

export const menuCatArray3 = [
  {
    id: 16,
    option: `Sopes`,
    value: "sopes",
  },
  {
    id: 17,
    option: `Tostadas`,
    value: `tostadas`,
  },
  {
    id: 18,
    option: `Tamales`,
    value: `tamales`,
  },
  {
    id: 19,
    option: `Quesadillas`,
    value: `quesadillas`,
  },
  {
    id: 20,
    option: `Sides`,
    value: `sides`,
  },
  {
    id: 21,
    option: `Kid's Meal`,
    value: "kids-meal",
  },
  {
    id: 22,
    option: `Desserts`,
    value: `desserts`,
  },
];

export const menuComboItems = [
  {
    id: 1,
    option: `ASADA TACO`,
    value: "ASADA-TACO",
  },
  {
    id: 2,
    option: `CHICKEN TACO`,
    value: "CHICKEN-TACO",
  },
  {
    id: 3,
    option: `SHREDDED CHICKEN TACO`,
    value: "SHREDDED-CHICKEN-TACO",
  },
  {
    id: 4,
    option: `PASTOR TACO`,
    value: "PASTOR-TACO",
  },
  {
    id: 5,
    option: `LENGUA TACO`,
    value: "LENGUA-TACO",
  },
  {
    id: 6,
    option: `CARNITAS TACO`,
    value: "CARNITAS-TACO",
  },
  {
    id: 7,
    option: `PICADILLO TACO/GROUND BEEF`,
    value: "PICADILLO-TACO",
  },
  {
    id: 8,
    option: `VEGETARIAN TACO`,
    value: "VEGETARIAN-TACO",
  },
  {
    id: 9,
    option: `CHILE RELLENO`,
    value: "CHILE-RELLENO",
  },
  {
    id: 10,
    option: `CHICKEN TAMAL`,
    value: "CHICKEN-TAMAL",
  },
  {
    id: 11,
    option: `QUESO CON RAJAS TAMAL`,
    value: "QUESO-CON RAJAS-TAMAL",
  },
  {
    id: 12,
    option: `PORK TAMAL`,
    value: "PORK-TAMAL",
  },
  {
    id: 13,
    option: `DULCE TAMAL`,
    value: "DULCE-TAMAL",
  },
  {
    id: 14,
    option: `CHEESE ENCHILADA`,
    value: "CHEESE-ENCHILADA",
  },
  {
    id: 15,
    option: `ASADA ENCHILADA`,
    value: "ASADA-ENCHILADA",
  },
  {
    id: 16,
    option: `CHICKEN ENCHILADA`,
    value: "CHICKEN-ENCHILADA",
  },
  {
    id: 17,
    option: `CARNITAS ENCHILADA`,
    value: "CARNITAS-ENCHILADA",
  },
  {
    id: 18,
    option: `PASTOR ENCHILADA`,
    value: "PASTOR-ENCHILADA",
  },
  {
    id: 19,
    option: `ASADA SOPE`,
    value: "ASADA-SOPE",
  },
  {
    id: 20,
    option: `CHICKEN SOPE`,
    value: "CHICKEN-SOPE",
  },
  {
    id: 21,
    option: `SHREDDED CHICKEN SOPE`,
    value: "SHREDDED-CHICKEN-SOPE",
  },
  {
    id: 22,
    option: `CARNITAS SOPE`,
    value: "CARNITAS-SOPE",
  },
  {
    id: 23,
    option: `PASTOR SOPE`,
    value: "PASTOR-SOPE",
  },
  {
    id: 24,
    option: `LENGUA SOPE`,
    value: "LENGUA-SOPE",
  },
  {
    id: 25,
    option: `VEGETARIAN SOPE`,
    value: "VEGETARIAN-SOPE",
  },
  {
    id: 26,
    option: `HARDSHELL ASADA TACO`,
    value: "HARDSHELL-ASADA-TACO",
  },
  {
    id: 27,
    option: `HARDSHELL CHICKEN TACO`,
    value: "HARDSHELL-CHICKEN-TACO",
  },
  {
    id: 28,
    option: `HARDSHELL SHREDDED CHICKEN TACO`,
    value: "HARDSHELL-SHREDDED-CHICKEN-TACO",
  },
  {
    id: 29,
    option: `HARDSHELL PICADILLO/GROUND BEEF TACO`,
    value: "HARDSHELL-PICADILLO-TACO",
  },
  {
    id: 30,
    option: `HARDSHELL LENGUA TACO`,
    value: "HARDSHELL-LENGUA-TACO",
  },
  {
    id: 31,
    option: `HARDSHELL PASTOR TACO`,
    value: "HARDSHELL-PASTOR-TACO",
  },
  {
    id: 32,
    option: `HARDSHELL CARNITAS TACO`,
    value: "HARDSHELL-CARNITAS-TACO",
  },
  {
    id: 33,
    option: `HARDSHELL VEGETARIAN TACO`,
    value: "HARDSHELL-VEGETARIAN-TACO",
  },
];

export const timeIntervals = [
  {
    id: 1,
    option: `9:30 AM`,
    value: "9:30 AM",
  },
  {
    id: 2,
    option: `9:45 AM`,
    value: "9:45 AM",
  },
  {
    id: 3,
    option: `10:00 AM`,
    value: "10:00 AM",
  },
  {
    id: 4,
    option: `10:15 AM`,
    value: "10:15 AM",
  },
  {
    id: 5,
    option: `10:30 AM`,
    value: "10:30 AM",
  },
  {
    id: 6,
    option: `10:45 AM`,
    value: "10:45 AM",
  },
  {
    id: 7,
    option: `11:00 AM`,
    value: "11:00 AM",
  },
  {
    id: 8,
    option: `11:15 AM`,
    value: "11:15 AM",
  },
  {
    id: 9,
    option: `11:30 AM`,
    value: "11:30 AM",
  },
  {
    id: 10,
    option: `11:45 AM`,
    value: "11:45 AM",
  },
  {
    id: 11,
    option: `12:00 PM`,
    value: "12:00 PM",
  },
  {
    id: 12,
    option: `12:15 PM`,
    value: "12:15 PM",
  },
  {
    id: 13,
    option: `12:30 PM`,
    value: "12:30 PM",
  },
  {
    id: 14,
    option: `12:45 PM`,
    value: "12:45 PM",
  },
  {
    id: 15,
    option: `1:00 PM`,
    value: "1:00 PM",
  },
  {
    id: 16,
    option: `1:15 PM`,
    value: "1:15 PM",
  },
  {
    id: 17,
    option: `1:30 PM`,
    value: "1:30 PM",
  },
  {
    id: 18,
    option: `1:45 PM`,
    value: "1:45 PM",
  },
  {
    id: 19,
    option: `2:00 PM`,
    value: "2:00 PM",
  },
  {
    id: 20,
    option: `2:15 PM`,
    value: "2:15 PM",
  },
  {
    id: 21,
    option: `2:30 PM`,
    value: "2:30 PM",
  },
  {
    id: 22,
    option: `2:45 PM`,
    value: "2:45 PM",
  },
  {
    id: 23,
    option: `3:00 PM`,
    value: "3:00 PM",
  },
  {
    id: 24,
    option: `3:15 PM`,
    value: "3:15 PM",
  },
  {
    id: 25,
    option: `3:30 PM`,
    value: "3:30 PM",
  },
  {
    id: 26,
    option: `3:45 PM`,
    value: "3:45 PM",
  },
  {
    id: 27,
    option: `4:00 PM`,
    value: "4:00 PM",
  },
  {
    id: 28,
    option: `4:15 PM`,
    value: "4:15 PM",
  },
  {
    id: 29,
    option: `4:30 PM`,
    value: "4:30 PM",
  },
  {
    id: 30,
    option: `4:45 PM`,
    value: "4:45 PM",
  },
  {
    id: 31,
    option: `5:00 PM`,
    value: "5:00 PM",
  },
  {
    id: 32,
    option: `5:15 PM`,
    value: "5:15 PM",
  },
  {
    id: 33,
    option: `5:30 PM`,
    value: "5:30 PM",
  },
  {
    id: 34,
    option: `5:45 PM`,
    value: "5:45 PM",
  },
  {
    id: 35,
    option: `6:00 PM`,
    value: "6:00 PM",
  },
  {
    id: 36,
    option: `6:15 PM`,
    value: "6:15 PM",
  },
  {
    id: 37,
    option: `6:30 PM`,
    value: "6:30 PM",
  },
  {
    id: 38,
    option: `6:45 PM`,
    value: "6:45 PM",
  },
  {
    id: 39,
    option: `7:00 PM`,
    value: "7:00 PM",
  },
  {
    id: 40,
    option: `7:15 PM`,
    value: "7:15 PM",
  },
  {
    id: 41,
    option: `7:30 PM`,
    value: "7:30 PM",
  },
  {
    id: 42,
    option: `7:45 PM`,
    value: "7:45 PM",
  },
  {
    id: 43,
    option: `8:00 PM`,
    value: "8:00 PM",
  },
  {
    id: 44,
    option: `8:15 PM`,
    value: "8:15 PM",
  },
  {
    id: 45,
    option: `8:30 PM`,
    value: "8:30 PM",
  },
];

export const timeIntervalsSunday = [
  {
    id: 4,
    option: `10:15 AM`,
    value: "10:15 AM",
  },
  {
    id: 5,
    option: `10:30 AM`,
    value: "10:30 AM",
  },
  {
    id: 6,
    option: `10:45 AM`,
    value: "10:45 AM",
  },
  {
    id: 7,
    option: `11:00 AM`,
    value: "11:00 AM",
  },
  {
    id: 8,
    option: `11:15 AM`,
    value: "11:15 AM",
  },
  {
    id: 9,
    option: `11:30 AM`,
    value: "11:30 AM",
  },
  {
    id: 10,
    option: `11:45 AM`,
    value: "11:45 AM",
  },
  {
    id: 11,
    option: `12:00 PM`,
    value: "12:00 PM",
  },
  {
    id: 12,
    option: `12:15 PM`,
    value: "12:15 PM",
  },
  {
    id: 13,
    option: `12:30 PM`,
    value: "12:30 PM",
  },
  {
    id: 14,
    option: `12:45 PM`,
    value: "12:45 PM",
  },
  {
    id: 15,
    option: `1:00 PM`,
    value: "1:00 PM",
  },
  {
    id: 16,
    option: `1:15 PM`,
    value: "1:15 PM",
  },
  {
    id: 17,
    option: `1:30 PM`,
    value: "1:30 PM",
  },
  {
    id: 18,
    option: `1:45 PM`,
    value: "1:45 PM",
  },
  {
    id: 19,
    option: `2:00 PM`,
    value: "2:00 PM",
  },
  {
    id: 20,
    option: `2:15 PM`,
    value: "2:15 PM",
  },
  {
    id: 21,
    option: `2:30 PM`,
    value: "2:30 PM",
  },
  {
    id: 22,
    option: `2:45 PM`,
    value: "2:45 PM",
  },
  {
    id: 23,
    option: `3:00 PM`,
    value: "3:00 PM",
  },
  {
    id: 24,
    option: `3:15 PM`,
    value: "3:15 PM",
  },
  {
    id: 25,
    option: `3:30 PM`,
    value: "3:30 PM",
  },
  {
    id: 26,
    option: `3:45 PM`,
    value: "3:45 PM",
  },
  {
    id: 27,
    option: `4:00 PM`,
    value: "4:00 PM",
  },
  {
    id: 28,
    option: `4:15 PM`,
    value: "4:15 PM",
  },
  {
    id: 29,
    option: `4:30 PM`,
    value: "4:30 PM",
  },
  {
    id: 30,
    option: `4:45 PM`,
    value: "4:45 PM",
  },
  {
    id: 31,
    option: `5:00 PM`,
    value: "5:00 PM",
  },
  {
    id: 32,
    option: `5:15 PM`,
    value: "5:15 PM",
  },
  {
    id: 33,
    option: `5:30 PM`,
    value: "5:30 PM",
  },
  {
    id: 34,
    option: `5:45 PM`,
    value: "5:45 PM",
  },
  {
    id: 35,
    option: `6:00 PM`,
    value: "6:00 PM",
  },
  {
    id: 36,
    option: `6:15 PM`,
    value: "6:15 PM",
  },
  {
    id: 37,
    option: `6:30 PM`,
    value: "6:30 PM",
  },
  {
    id: 38,
    option: `6:45 PM`,
    value: "6:45 PM",
  },
  {
    id: 39,
    option: `7:00 PM`,
    value: "7:00 PM",
  },
  {
    id: 40,
    option: `7:15 PM`,
    value: "7:15 PM",
  },
  {
    id: 41,
    option: `7:30 PM`,
    value: "7:30 PM",
  },
  {
    id: 42,
    option: `7:45 PM`,
    value: "7:45 PM",
  },
  {
    id: 43,
    option: `8:00 PM`,
    value: "8:00 PM",
  },
  {
    id: 44,
    option: `8:15 PM`,
    value: "8:15 PM",
  },
  {
    id: 45,
    option: `8:30 PM`,
    value: "8:30 PM",
  },
];
